import { Arrears } from './Arrears';

export const getLatestArrears = (arrears: Arrears[]) => {
  const sortedArrears = [...arrears].sort((a, b) =>
    a.reportingPeriodDate > b.reportingPeriodDate ? -1 : 1
  );
  const inactiveArrears = sortedArrears.filter((a) => a.reportingPeriodStatus === 'closed');
  if (inactiveArrears.length > 0) {
    return inactiveArrears[0];
  }

  return sortedArrears[0];
};
